/**
 * Progress Tracker is used to show steps of progress
 *
 * @param $scope
 * @param options {}
 * autoScroll: (Boolean) whether to let the progress tracker to take control of the scrolling of the page
 * scrollElement: (jQuery Selector) Default is parent element, the scrollable element used by autoscroll
 * items: (Object) id, title, disabled[Optional]
 *
 * @constructor
 */
window.ProgressTracker = function ($scope, options) {
    var self = this;

    // Reverse indices used to map items ids to corresponding item
    var reverseIndices = {};
    var element;
    var currentActive;
    var inInputFocusMode;
    const domMutationObserver = new YDomMutationObserver();

    // This will stop listening to element scroll if set to true (used from inside the progress tracker only)
    var holdScrollDetection = false;

    self.autoScroll = options.autoScroll || false;
    self.scrollElement = options.scrollElement || false;
    self.stepIcons = options.stepIcons || {
            error: 'fa fa-circle',
            complete: 'fa fa-check',
            active: 'fa fa-circle'
        };
    self.items = [];

    for (var i in options.items) {
        self.items[i] = {
            id: options.items[i].id,
            title: options.items[i].title || '',
            // Initial state is new, or disabled if disabled flag is set
            state: options.items[i].disabled ? ProgressTracker.States.DISABLED : ProgressTracker.States.NEW,
            active: false
        };

        reverseIndices[options.items[i].id] = i;
    }

    self.getItem = function (id) {
        return self.items[reverseIndices[id]];
    };

    /**
     * Get the scrollable element, default is parent element or from options
     *
     * @returns {*}
     */
    var getScrollElement = function () {
        if (self.scrollElement) {
            return $(self.scrollElement);
        }

        return element.parent();
    };

    /**
     * Change state of specific item
     * @param id (String)
     * @param newState (String)
     */
    self.changeState = function (id, newState) {
        var itemIndex = reverseIndices[id];
        var oldState = self.items[itemIndex].state;

        if (newState != oldState) {
            self.items[itemIndex].state = newState;
            if (options.onStateChanged) options.onStateChanged(self.items[itemIndex], newState, oldState);
        }
    };

    /**
     * Change title of specific item
     * @param id (String)
     * @param newTitle (String)
     */
    self.changeTitle = function (id, newTitle) {
        var itemIndex = reverseIndices[id];
        var oldTitle = self.items[itemIndex].state;

        if (newTitle != oldTitle) {
            self.items[itemIndex].title = newTitle;
            //@TODO: check if we need to trigger the onChange
        }
    };

    /**
     * get state of specific item
     * @param id (String)
     */
    self.getState = function (id) {
        return reverseIndices[id] && self.items[reverseIndices[id]] && self.items[reverseIndices[id]].state;
    };

    /**
     * Get next item after given id
     * @param id (String)
     * @returns {*}
     */
    self.getNext = function (id) {
        var itemIndex = reverseIndices[id];

        return self.items[++itemIndex];
    };

    /**
     * Go to element, activate it and scroll to it
     *
     * @param id
     */
    self.goTo = function (id) {
        var delay = self.autoScroll ? 200 : 1;

        // To avoid issues with Angular digest loop
        setTimeout(function () {
            changeActiveItem(self.items[reverseIndices[id]]);
        }, delay);

        if (self.autoScroll) {
            var targetTop = $('#' + id).offset().top;
            var parentTop = ($('#' + id).parent().offset().top - 5) || 0;

            holdScrollDetection = true;

            if (getScrollElement().offset()) {
                getScrollElement().animate({'scrollTop': (targetTop - parentTop) + 'px'}, function () {
                    holdScrollDetection = false
                });
            }
            else {
                $('body').animate({'scrollTop': (targetTop - parentTop) + 'px'}, function () {
                    holdScrollDetection = false
                });
            }
        }
    };

    /**
     * Not for use, only used from the progress tracker for internal use
     * Use options.onItemClick
     *
     * @param event
     * @param item
     */
    self.onItemClick = function (event, item) {
        if (item.state === ProgressTracker.States.DISABLED) {
            return;
        }

        if (options.onItemClick) {
            options.onItemClick(event, item);
        }
        else {
            self.goTo(item.id);
        }
    };

    /**
     * Private use by progress tracker
     * @param elm
     */
    self.directiveLinked = function (elm) {
        element = elm;

        if (options.onInitialized) options.onInitialized(element);

        if (self.autoScroll) {
            hideTrackerOnInputFocus();
            handleScrolling();
        }
    };

    self.directiveDestroyed = () => {
        domMutationObserver?.destroy();
    };

    self.getMainElement = function () {
        return element;
    };

    /**
     * This function attach does the necessary work to listen for input focus/blur to hide the progress tracker
     * This is useful in case of mobile view
     */
    var hideTrackerOnInputFocus = function () {

        var SHOW_ON_RESIZE_TIMEOUT = 500;
        var DELAY_THE_ACTION_TIMEOUT = 200;

        var inputsSelectors = ["input[type='text']", "input[type='password']", "input[type='email']", "input[type='tel']", "textarea"];

        var listenerHandler;

        var screenSize = $(window).height() * $(window).width();

        const trackerListenerHandler = function () {
            clearTimeout(listenerHandler);

            // Run this block of code only once
            if (!listenerHandler) {
                // Scroll to 0 in start
                getScrollElement().scrollTop(0);
            }

            listenerHandler = setTimeout(function () {

                element.parent().find(inputsSelectors.join(",")).focus(function (e) {
                    element.hide();
                    inInputFocusMode = true;
                    getScrollElement().scroll();
                    changeActiveItem(null);

                    $(window).off('resize');
                    let resizeTimeout;

                    // On Android, blur is not always triggered, so we have to listen for the window resize after a period of time so that the input keyboard is closed
                    $(window).on("resize", function () {

                        clearTimeout(resizeTimeout);

                        resizeTimeout = setTimeout(function () {
                            const currentScreenSize = $(window).height() * $(window).width();

                            if (currentScreenSize >= screenSize) {
                                inInputFocusMode = false;
                                element.show();
                                getScrollElement().scroll();
                                $(window).off('resize');
                            }

                        }, SHOW_ON_RESIZE_TIMEOUT);
                    });
                });

                element.parent().find(inputsSelectors.join(",")).blur(function () {
                    inInputFocusMode = false;
                    setTimeout(function () {
                        if (!inInputFocusMode) {
                            element.show();
                            getScrollElement().scroll();
                        }
                    }, DELAY_THE_ACTION_TIMEOUT)
                });

            }, DELAY_THE_ACTION_TIMEOUT);
        };

        domMutationObserver.init(element[0]);
        domMutationObserver.on(YDomMutationObserver.EVENTS.ON_CHILD_LIST_CHANGED, trackerListenerHandler);
        domMutationObserver.on(YDomMutationObserver.EVENTS.ON_SUBTREE_CHANGED, trackerListenerHandler);
        domMutationObserver.on(YDomMutationObserver.EVENTS.ON_CHANGE, trackerListenerHandler);
        domMutationObserver.startListening();
    };

    /**
     * Change a specific element to active state
     *
     * @param activeItem (item) new active element, can be null
     */
    var changeActiveItem = function (activeItem) {

        if (!currentActive && !activeItem) {
            return;
        }

        if (currentActive && activeItem && activeItem.id == currentActive.id) {
            return;
        }

        if ([ProgressTracker.States.DISABLED, ProgressTracker.States.DONE].indexOf(activeItem.state) > -1) {
            return;
        }

        var lastActive = currentActive;

        if (currentActive) {
            if (!currentActive.element) {
                currentActive.element = getScrollElement().find('#' + currentActive.id);
            }

            currentActive.active = false;
            currentActive.element.find(".progress-tracker-title").removeClass("fixed");
            currentActive.element.find(".titlePlaceholder").remove();
        }

        activeItem.active = true;

        if (!activeItem.element) {
            activeItem.element = element.parent().find('#' + activeItem.id);
        }

        if (self.autoScroll) {

            activeItem.element.find(".progress-tracker-title").css({
                "top": parseInt(element.find(".progress-tracker-content").outerHeight()) + parseInt(element.find(".progress-tracker-content").css("top"))
            });

            activeItem.element.find(".progress-tracker-title").addClass("fixed");
            activeItem.element.prepend('<div class="titlePlaceholder" style="height:' + activeItem.element.find(".progress-tracker-title").outerHeight() + 'px"></div>');
        }
        else {
            $(".progress-tracker-section").hide();
            activeItem.element.show();
        }

        currentActive = activeItem;
        if (options.onActiveChanged) options.onActiveChanged(currentActive, lastActive);

        $scope.$apply();
    };

    /**
     * Handle scrolling if enabled or not holded
     */
    var handleScrolling = function () {
        if (!self.autoScroll) {
            return;
        }

        var $scrollElement = getScrollElement();

        var lastScroll = 0;

        $scrollElement.off('scroll');

        var scrollHandler = function () {

            if (holdScrollDetection || inInputFocusMode) return;

            var direction = 'down';

            if ($scrollElement.scrollTop() < lastScroll) {
                direction = 'up';
            }

            lastScroll = $scrollElement.scrollTop();

            var maxNegative = -99999;
            var activeItem;

            var parentOffset = (parseInt(element.find(".progress-tracker-content").outerHeight()) + parseInt($(".progress-tracker-content").css("top"))) || 0;

            var currentActiveTitleHeight = 50;
            var activeAdjacent;

            if (currentActive) {
                currentActiveTitleHeight = currentActive.element.find('.progress-tracker-title').outerHeight() || 0;
            }

            var visibleActiveItems = [];

            for (var i in self.items) {
                var id = self.items[i].id;
                if (!self.items[i].element) {
                    self.items[i].element = element.parent().find('#' + self.items[i].id);
                }

                if (self.items[i].element && self.items[i].element.length && self.items[i].element.is(":visible")) {

                    if (self.items[i].state != ProgressTracker.States.DISABLED) {
                        visibleActiveItems.push(self.items[i]);
                    }

                    var offset = self.items[i].element.offset().top - parentOffset - $scrollElement.scrollTop();

                    if (direction == 'down') {

                        if (currentActiveTitleHeight && offset > 0 && offset <= currentActiveTitleHeight && !self.items[i].active) {
                            activeAdjacent = self.items[i];
                        }

                        if (offset <= 0 && offset > maxNegative) {
                            maxNegative = offset;
                            activeItem = self.items[i];
                        }
                    }
                    else if (offset <= currentActiveTitleHeight && offset > maxNegative) {
                        maxNegative = offset;
                        activeItem = self.items[i];
                    }
                }

            }

            if (visibleActiveItems.length === 1) {
                activeItem = visibleActiveItems[0];

                activeItem.element.find('.progress-tracker-title').css('top', parseInt(element.find(".progress-tracker-content").outerHeight()) + parseInt(element.find(".progress-tracker-content").css('top')) + 'px');
                return changeActiveItem(activeItem);
            }

            if (activeAdjacent) {

                var offset = activeAdjacent.element.offset().top - parentOffset - $scrollElement.scrollTop();

                if (currentActive && direction == 'down') {
                    var currentActiveTitleHeight = currentActive.element.find('.progress-tracker-title').outerHeight() || 0;
                    currentActive.element.find('.progress-tracker-title').css('top', parseInt(element.find(".progress-tracker-content").outerHeight()) + parseInt(element.find(".progress-tracker-content").css('top')) + (offset - currentActiveTitleHeight) + 'px');
                }
                // else {
                //   currentActive.element.find('.progress-tracker-title').css('top', parseInt(element.find(".progress-tracker-content").outerHeight()) + 'px');
                //}
            }
            else if (currentActive) {
                currentActive.element.find('.progress-tracker-title').css('top', parseInt(element.find(".progress-tracker-content").outerHeight()) + parseInt(element.find(".progress-tracker-content").css('top')) + 'px');
            }

            changeActiveItem(activeItem);
        };

        $scrollElement.on('scroll', scrollHandler);
    }
};

ProgressTracker.States = {
    /**
     * Complete state constant
     */
    COMPLETE: 'complete',
    /**
     * Same as Complete but disable click and scrolling
     */
    DONE: 'done',
    /**
     * Error state constant
     */
    ERROR: 'error',
    /**
     * New state constant
     */
    NEW: 'new',
    /**
     * Disabled state constant
     */
    DISABLED: 'disabled'
};
